<template>
    <div class="LogQuery">
        <div class="LogQuery_inner">
            <div class="Select">
                <el-select v-model="searchInfo.Type" placeholder="请选择类型" size="medium"
                           style="width: 180px;margin-right: 5px" clearable>
                    <el-option v-for="item in Types" :key="item.id" :label="item.label"
                               :value="item.id"></el-option>
                </el-select>
                <el-date-picker
                        v-model="searchInfo.BeginTime" type="datetime" placeholder="扫码开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss" size="medium"
                        style="width: 200px;margin-right: 5px">
                </el-date-picker>
                <el-date-picker
                        v-model="searchInfo.EndTime" type="datetime" placeholder="扫码结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss" size="medium"
                        style="width: 200px;margin-right: 5px">
                </el-date-picker>
                <el-button type="primary" size="medium" @click="getLogQueryList">查询
                </el-button>
                <el-button style="float: right" type="primary" size="medium" @click="downloadProduction">导出</el-button>

            </div>

            <div>
                <el-table :data="LogQueryList" style="width: 100%" max-height="520px">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="Subject" label="标题" align="center" width="200">
                        <template slot-scope="scope">
                            <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{scope.row.Subject}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="message" label="内容" align="center">
                        <template slot-scope="scope">
                            <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{scope.row.message}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Op_time" label="时间" align="center" width="180"></el-table-column>
                    <el-table-column prop="Factory_no" label="工厂" align="center" width="120"></el-table-column>
                    <el-table-column prop="Type" label="类型" align="center" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.Type == 1">操作日志</span>
                            <span v-if="scope.row.Type == 2">错误日志</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="100">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="edit(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--<div class="pagination" style="margin: 0 auto;padding-top: 20px">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="searchInfo.pageNo"
                        :page-sizes="pageSizes"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>-->

            <!--弹框-->
            <div>
                <!--会场新增编辑-->
                <el-dialog :title="title" :visible.sync="isShow" width="400px" custom-class="pop-dialog">
                    <el-form :model="formData" label-width="90px" label-position="top" ref="formData"
                             class="demo-ruleForm">
                        <el-form-item label="标题: ">
                            <el-input type="textarea" :rows="3" v-model="formData.Subject" size="small"
                                      style="width: 100%" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="内容: ">
                            <el-input type="textarea" :rows="5" v-model="formData.message" size="small"
                                      style="width: 100%" readonly></el-input>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>

    import {GetLogQueryList} from '@/assets/js/api'

    export default {
        name: "LogQuery",
        data() {
            return {
                LogQueryList: [],
                searchInfo: {
                    Type: '',//类型
                    BeginTime: '',//开始日期
                    EndTime: '',//结束日期
                },
                pageSizes: [10, 20, 50, 100, 200, 500, 1000],
                total: 0,
                Types: [
                    {id: 1, label: '操作日志'},
                    {id: 2, label: '错误日志'},
                ],

                isShow: false,
                title: '',
                formData: {
                    Subject: '',
                    message: '',
                }
            }
        },
        created() {
            this.getLogQueryList()
        },
        methods: {
            // 获取数据
            getLogQueryList() {

                if (!this.searchInfo.BeginTime) {
                    this.searchInfo.BeginTime = ''
                }
                if (!this.searchInfo.EndTime) {
                    this.searchInfo.EndTime = ''
                }

                GetLogQueryList(this.searchInfo).then(res => {
                    if (res.data.ReturnCode == 0) {
                        this.LogQueryList = res.data.Data
                    } else {
                        this.LogQueryList = []
                    }
                })
            },

            /*// 翻页
            // 每页条数改变
            handleSizeChange(val) {
                this.searchInfo.pageSize = val
                this.getLogQueryList(2)
            },

            // 页数改变
            handleCurrentChange(val) {
                this.searchInfo.pageNo = val
                this.getLogQueryList(2)
            },*/

            // 查看
            edit(row) {
                this.formData = row;
                this.isShow = true;
                this.title = '详情';
            },

            downloadProduction() {
                this.openFullScreen();
                GetLogQueryList(this.searchInfo).then(res => {
                    if (res.data.ReturnCode == 0) {
                        this.LogQueryList = res.data.Data
                        this.handleDownload();
                    } else {
                        this.LogQueryList = []
                    }
                })
            },

            openFullScreen() {
                this.loading = this.$loading({
                    lock: true,
                    text: '导出中，请稍后',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },

            // 导出数据
            handleDownload() {
                require.ensure([], () => {
                    const {export_json_to_excel} = require('@/assets/js/Export2Excel')
                    const tHeader = ['标题', '内容', '时间', '工厂', '类型：1=操作日志  2=错误日志']
                    const filterVal = ['Subject', 'message', 'Op_time', 'Factory_no', 'Type']
                    const list = this.LogQueryList;
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '信息列表')
                    this.loading.close();
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    if (j === 'Status') {
                        return this.updateType(null, null, v[j])
                    } else {
                        return v[j]
                    }
                }))
            },
        },
        watch: {
            isShow(to) {
                if (!to) {
                    this.formData = {
                        formData: {
                            Subject: '',
                            message: '',
                        }
                    };
                    this.getLogQueryList();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .LogQuery {
        padding: 20px 20px 10px;
        .LogQuery_inner {
            padding: 20px 30px 30px 30px;
            width: calc(100% - 60px);
            min-height: calc(100vh - 155px);
            background: #fff;
            display: flex;
            flex-direction: column;
            font-size: 12px !important;
            .breadcrumb {
                align-items: center;
                justify-content: center;
                .el-breadcrumb {
                    font-size: 15px;
                    line-height: 2;
                }
            }
        }
    }
</style>

<style scoped>
    .Select {
        margin: 10px 0px;
    }
</style>

<style scoped>
    >>> .el-dialog__body {
        padding: 10px 20px;
    }

    >>> .el-form-item {
        margin-bottom: 0px;
    }

    >>> .el-form--label-top .el-form-item__label {
        float: none;
        display: inline-block;
        text-align: left;
        padding: 0;
        line-height: 20px;
    }

    >>> .el-form-item__error {
        padding-top: 0px;
        top: 95%;
        left: auto;
        right: 0;
    }
</style>
